import { createContext, useContext, useEffect, useState } from "react";

export const copy = {
    en: {
        meta: {
            title: "LARIVA | Italian Lakes Collection – Italian Mineral Water",
            description:
                "LARIVA is a premium Italian mineral water collection inspired by the elegance of the Italian lakes, created for selected hotels, yachts, private villas and exceptional hospitality destinations.",
        },
        nav: {
            collection: "Collection",
            story: "Story",
            hospitality: "Hospitality",
            contact: "Contact",
            request: "Request Access",
        },
        hero: {
            eyebrow: "Italian Mineral Water",
            title1: "Inspired by",
            title2: "Italian Lakeside",
            title3: "Elegance",
            collection: "LARIVA / ITALIAN LAKES COLLECTION",
            desc1: "A premium Italian mineral water inspired",
            desc2: "by the beauty, balance and timeless elegance",
            desc3: "of the Italian lakes.",
            cta: "Discover the Collection",
            badge: "PURE. ELEVATED. TIMELESS.",
        },
        marquee: ["PURE", "ELEVATED", "TIMELESS", "LARIVA", "ITALIAN LAKES COLLECTION", "ITALIAN MINERAL WATER"],
        collection: {
            title: "The Collection",
            still: {
                name: "Still",
                text: "Naturally still mineral water with a pure, balanced profile and refined Italian character.",
                f1: ["Natural", "Still"],
                f2: ["Low Mineral", "Content"],
                cta: "Discover Still",
            },
            sparkling: {
                name: "Sparkling",
                text: "Naturally sparkling mineral water with fine bubbles, freshness and a crisp, elegant taste.",
                f1: ["Fine", "Bubbles"],
                f2: ["Refreshing", "Taste"],
                cta: "Discover Sparkling",
            },
        },
        story: {
            chapter: "Una Storia Italiana",
            title: "Our Story",
            p1: "Born from an idea inspired by the elegance of the Italian lakes, LARIVA is more than water: it is a tribute to refined hospitality, beauty and timeless Italian style.",
            p2: "A landscape where water, mountains, architecture and Italian style have created an unmistakable sense of place.",
            p3: "LARIVA takes inspiration from this world to create a mineral water collection designed for exceptional hospitality.",
            tag: "Inspired by Italian Lakeside Elegance. Made in Italy.",
            cta: "Discover Our Story",
        },
        hospitality: {
            chapter: "Ospitalità",
            title: "Exclusively for Hospitality",
            p1: "Created for selected hotels, resorts, lake clubs, yachts and exceptional destinations.",
            emphasis: "Reserved for elite hospitality partners.",
            cta: "Learn More",
        },
        places: {
            title: "Created for Exceptional Places",
            items: ["Hotels", "Lake Clubs", "Yachts", "Private Villas", "Events", "Wellness"],
            bottom: "For hotels, lake clubs, yachts, villas and exceptional places.",
        },
        statement: {
            title1: "Not Everywhere.",
            title2: "Only Where It Belongs.",
            text: "LARIVA is created for selected hospitality destinations that share our vision of quality, design and Italian elegance.",
        },
        request: {
            title: "Request Access",
            sub: "Discover LARIVA for your property, venue or hospitality concept.",
            fields: {
                name: "Name",
                company: "Company / Property",
                role: "Role",
                email: "Email",
                phone: "Phone",
                country: "Country",
                venue: "Type of Venue",
                message: "Message",
            },
            venues: ["Hotel", "Resort", "Restaurant / Club", "Yacht", "Private Villa", "Event", "Wellness", "Distributor", "Other"],
            cta: "Request Information",
            note: "Hospitality enquiries only.",
            successTitle: "Thank you.",
            successText: "Your request has been received. Our hospitality team will contact you shortly.",
            error: "Something went wrong. Please try again.",
        },
        footer: {
            tag1: "Italian Mineral Water.",
            tag2: "Inspired by Italian Lakeside Elegance.",
            tag3: "Made in Italy.",
            col1: "Collection",
            col1Links: ["Still", "Sparkling", "Our Packaging"],
            col2: "About",
            col2Links: ["Our Story", "Quality & Source", "Sustainability"],
            col3: "Hospitality",
            col3Links: ["For Selected Partners", "Private Label", "Request Access"],
            col4: "Contact",
            rights: "© LARIVA Italian Lakes Collection. All rights reserved.",
            privacy: "Privacy Policy",
            terms: "Terms & Conditions",
        },
    },
    it: {
        meta: {
            title: "LARIVA | Italian Lakes Collection – Acqua Minerale Italiana",
            description:
                "LARIVA è una collezione italiana di acqua minerale premium ispirata all'eleganza dei laghi italiani, creata per hotel selezionati, yacht, ville private e destinazioni hospitality d'eccellenza.",
        },
        nav: {
            collection: "Collezione",
            story: "Storia",
            hospitality: "Hospitality",
            contact: "Contatti",
            request: "Richiedi Accesso",
        },
        hero: {
            eyebrow: "Italian Mineral Water",
            title1: "Inspired by",
            title2: "Italian Lakeside",
            title3: "Elegance",
            collection: "LARIVA / ITALIAN LAKES COLLECTION",
            desc1: "Un'acqua minerale italiana premium ispirata",
            desc2: "alla bellezza, all'equilibrio e all'eleganza",
            desc3: "senza tempo dei laghi italiani.",
            cta: "Scopri la Collezione",
            badge: "PURE. ELEVATED. TIMELESS.",
        },
        marquee: ["PURE", "ELEVATED", "TIMELESS", "LARIVA", "ITALIAN LAKES COLLECTION", "ITALIAN MINERAL WATER"],
        collection: {
            title: "La Collezione",
            still: {
                name: "Still",
                text: "Acqua minerale naturalmente liscia, dal profilo puro ed equilibrato e dal carattere italiano raffinato.",
                f1: ["Naturalmente", "Liscia"],
                f2: ["Basso Contenuto", "Minerale"],
                cta: "Scopri Still",
            },
            sparkling: {
                name: "Sparkling",
                text: "Acqua minerale naturalmente frizzante, dalle bollicine fini, fresca e dal gusto nitido ed elegante.",
                f1: ["Bollicine", "Fini"],
                f2: ["Gusto", "Rinfrescante"],
                cta: "Scopri Sparkling",
            },
        },
        story: {
            chapter: "Una Storia Italiana",
            title: "La Nostra Storia",
            p1: "Nata da un'idea ispirata dall'eleganza dei laghi italiani, LARIVA è più di un'acqua: è un tributo all'hospitality raffinata, alla bellezza e allo stile italiano senza tempo.",
            p2: "Un paesaggio dove acqua, montagne, architettura e stile italiano hanno creato un senso del luogo inconfondibile.",
            p3: "LARIVA trae ispirazione da questo mondo per creare una collezione di acqua minerale pensata per l'hospitality d'eccezione.",
            tag: "Inspired by Italian Lakeside Elegance. Made in Italy.",
            cta: "Scopri la Nostra Storia",
        },
        hospitality: {
            chapter: "Ospitalità",
            title: "Esclusivamente per l'Hospitality",
            p1: "Creata per hotel, resort, lake club, yacht e destinazioni d'eccezione selezionati.",
            emphasis: "Riservata a partner hospitality d'élite.",
            cta: "Scopri di Più",
        },
        places: {
            title: "Creata per Luoghi Eccezionali",
            items: ["Hotel", "Lake Club", "Yacht", "Ville Private", "Eventi", "Wellness"],
            bottom: "Per hotel, lake club, yacht, ville e luoghi eccezionali.",
        },
        statement: {
            title1: "Non Ovunque.",
            title2: "Solo Dove Appartiene.",
            text: "LARIVA è creata per destinazioni hospitality selezionate che condividono la nostra visione di qualità, design ed eleganza italiana.",
        },
        request: {
            title: "Richiedi Accesso",
            sub: "Scopri LARIVA per la tua proprietà, il tuo locale o il tuo concept hospitality.",
            fields: {
                name: "Nome",
                company: "Azienda / Proprietà",
                role: "Ruolo",
                email: "Email",
                phone: "Telefono",
                country: "Paese",
                venue: "Tipo di Struttura",
                message: "Messaggio",
            },
            venues: ["Hotel", "Resort", "Ristorante / Club", "Yacht", "Villa Privata", "Evento", "Wellness", "Distributore", "Altro"],
            cta: "Richiedi Informazioni",
            note: "Solo richieste hospitality.",
            successTitle: "Grazie.",
            successText: "La tua richiesta è stata ricevuta. Il nostro team hospitality ti contatterà a breve.",
            error: "Qualcosa è andato storto. Riprova.",
        },
        footer: {
            tag1: "Italian Mineral Water.",
            tag2: "Inspired by Italian Lakeside Elegance.",
            tag3: "Made in Italy.",
            col1: "Collezione",
            col1Links: ["Still", "Sparkling", "Il Packaging"],
            col2: "Il Brand",
            col2Links: ["La Nostra Storia", "Qualità e Fonte", "Sostenibilità"],
            col3: "Hospitality",
            col3Links: ["Per Partner Selezionati", "Private Label", "Richiedi Accesso"],
            col4: "Contatti",
            rights: "© LARIVA Italian Lakes Collection. Tutti i diritti riservati.",
            privacy: "Privacy Policy",
            terms: "Termini e Condizioni",
        },
    },
};

const LangContext = createContext(null);

const detectInitialLang = () => {
    if (window.location.pathname.startsWith("/it")) return "it";
    const saved = window.localStorage.getItem("lariva-lang");
    return saved === "it" ? "it" : "en";
};

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(detectInitialLang);

    useEffect(() => {
        window.localStorage.setItem("lariva-lang", lang);
        const homePaths = ["/", "/it"];
        if (homePaths.includes(window.location.pathname)) {
            const meta = copy[lang].meta;
            document.documentElement.lang = lang;
            document.title = meta.title;
            document
                .querySelector('meta[name="description"]')
                ?.setAttribute("content", meta.description);
            const target = lang === "it" ? "/it" : "/";
            if (window.location.pathname !== target) {
                window.history.replaceState(null, "", target);
            }
        }
    }, [lang]);

    return (
        <LangContext.Provider value={{ lang, setLang, t: copy[lang] }}>
            {children}
        </LangContext.Provider>
    );
};

export const useLang = () => useContext(LangContext);
